import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";

export const Auth0ProviderWrapper = ({ children }) => {
  // const history = useHistory();

  const domain = process.env.AUTH0_DOMAIN;
  const clientId = process.env.AUTH0_CLIENT_ID;
  const redirectUri = process.env.AUTH0_CALLBACK_URL;

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        response_type: "id_token",
        scope: "openid profile email",
      }}
    >
      {children}
    </Auth0Provider>
  );
};
